import { generalIconsList } from 'react-scale/components/ui/general-icons';

export const whyHeader = {
  overtitle: 'why rapid',
  title: 'Stop Waiting for Your Labels.',
  subtitle:
    'Often, quality labeled data will be the blocker in experimenting with different model setups. Slow iteration speed with labeling can significantly slow down AI development.'
};

export const dataInputsHeader = {
  overtitle: 'data inputs',
  title: 'Supported Annotation Types.'
};

export const dataInputsFeatures = {
  scaleText: [
    {
      img: generalIconsList.textClassification,
      title: 'Classification'
    },
    {
      img: generalIconsList.textNamedEntityRecognition,
      title: 'Named Entity Recognition'
    },
    {
      img: generalIconsList.textTranscription,
      title: 'Transcription'
    }
  ],
  scaleAudio: [
    {
      img: generalIconsList.audioClassification,
      title: 'Classification'
    },
    {
      img: generalIconsList.audioTranscription,
      title: 'Transcription'
    }
  ],
  scale3dSensorFusion: [
    {
      img: generalIconsList['3dSensorFusionCuboid'],
      title: 'Cuboid'
    }
  ],
  scaleVideo: [
    {
      img: generalIconsList.videoBoundingBox,
      title: 'Bounding Box'
    },
    {
      img: generalIconsList.videoClassification,
      title: 'Classification'
    },
    {
      img: generalIconsList.videoCuboid,
      title: 'Cuboid'
    },
    {
      img: generalIconsList.videoMultiGeometry,
      title: 'Ellipse (Multi-Geometry)'
    },
    {
      img: generalIconsList.videoLinesAndSplines,
      title: 'Lines & Splines'
    },
    {
      img: generalIconsList.videoPoint,
      title: 'Point'
    },
    {
      img: generalIconsList.videoPolygon,
      title: 'Polygon'
    },
    {
      img: generalIconsList.videoSemanticSegmentation,
      title: 'Segmentation'
    }
  ],
  scaleImage: [
    {
      img: generalIconsList.imageBoundingBox,
      title: 'Bounding Box'
    },
    {
      img: generalIconsList.imageClassification,
      title: 'Classification'
    },
    {
      img: generalIconsList.imageCuboid,
      title: 'Cuboid'
    },
    {
      img: generalIconsList.imageMultiGeometry,
      title: 'Ellipse (Multi-Geometry)'
    },
    {
      img: generalIconsList.imageLinesAndSplines,
      title: 'Lines & Splines'
    },
    {
      img: generalIconsList.imagePoint,
      title: 'Point'
    },
    {
      img: generalIconsList.imagePolygon,
      title: 'Polygon'
    },
    {
      img: generalIconsList.imageSemanticSegmentation,
      title: 'Segmentation'
    }
  ]
};

export const dataInputsLanguages = [
  {
    flag: 'US',
    language: 'English'
  },
  {
    flag: 'TH',
    language: 'Thai'
  },
  {
    flag: 'GR',
    language: 'Greek'
  },
  {
    flag: 'VN',
    language: 'Vietnamese'
  },
  {
    flag: 'TN',
    language: 'Turkish'
  },
  {
    flag: 'ES',
    language: 'Spanish'
  },
  {
    flag: 'RU',
    language: 'Russian'
  },
  {
    flag: 'PT',
    language: 'Portuguese'
  },
  {
    flag: 'PL',
    language: 'Polish'
  },
  {
    flag: 'KR',
    language: 'Korean'
  },
  {
    flag: 'JP',
    language: 'Japanese'
  },
  {
    flag: 'IT',
    language: 'Italian'
  },
  {
    flag: 'DE',
    language: 'German'
  },
  {
    flag: 'FR',
    language: 'French'
  },
  {
    flag: 'CN',
    language: 'Chinese'
  },
  {
    flag: 'AE',
    language: 'Arabic'
  }
];

export const HowItWorksHeader = {
  overtitle: 'How It Works',
  title: 'Setup, Calibrate, Scale',
  subtitle:
    'Start with a calibration batch to iterate on your labeling instructions in a matter of hours. Progress to a production batch of 3k+ tasks turned around in days, not weeks.'
};
